import "flatpickr/dist/themes/light.css";

import Flatpickr from "react-flatpickr";

import { styles } from "@repo/helpers";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { InternalDatePickerMarkupProps } from "./types";

export function DateTimePickerMarkup(props: InternalDatePickerMarkupProps) {
	const { placeholder, datePickerOptions, ...inputProps } = props;
	const { id, name, disabled, value, error, className } = inputProps;
	const { allowInput } = datePickerOptions;
	const { onChange, onOpen } = props;

	return (
		<InputComponent {...inputProps} clear={() => onChange([], undefined, null)}>
			<Flatpickr
				onChange={onChange}
				onOpen={onOpen}
				onBlur={props.onUnfocused}
				id={id}
				name={name || id}
				disabled={disabled}
				value={value}
				placeholder={placeholder ?? "M.D.YY or M.D.YYYY"}
				readOnly={!allowInput}
				options={datePickerOptions}
				className={styles(style.formControl, className, disabled && style.disabled, error && style.error)}
				inputMode="decimal"
			/>
		</InputComponent>
	);
}
